import React, { FC, useEffect } from "react";
import { useRoutes, Navigate } from "react-router-dom";
import { useAppDispatch } from "src/hooks/redux";
import { getIndustriesAsync } from "src/redux/industries/actions";
import { getCurrentUserAsync } from "src/redux/currentUser/actions";
import { getCloneTypesAsync } from "src/redux/cloneTypes/actions";
import { getCountriesAsync } from "src/redux/countries/actions";
import { PrivateRoute } from "src/components/PrivateRoute";
import { ONLY_FOR } from "src/components/PrivateRoute/types";
import {
  Home,
  Clones,
  MyClonesCreate,
  MyClonesEdit,
  UserProfile,
  InquiryItem,
  ChatItem,
  Registration,
  Cabinet,
  MyInquiries,
  CloneItem,
  Favorites,
  Watchlist,
  UserProfileInfo,
  UserProfileClones,
  UserProfileInquiries,
  MyClones,
  CreateInquiry,
  EditInquiry,
  Deals,
  DealItem,
  Inquiries,
  AboutUs,
  Opportunities,
  Blog,
  BlogItem,
  Settings,
  CookiePolicy,
  PrivacyPolicy,
  TermsOfUse,
  NotFound,
  ContactUs,
} from "src/pages";
import { PATHNAMES } from "src/constants/routes";
import { getMetaDataAsync } from "src/redux/metadata/actions";

const ROUTES = [
  {
    element: <Home />,
    path: PATHNAMES.HOME,
  },
  {
    element: <Clones />,
    path: PATHNAMES.CLONES,
  },
  {
    element: <PrivateRoute component={ChatItem} />,
    path: PATHNAMES.CHAT_ITEM,
  },
  {
    element: (
      <PrivateRoute component={Registration} onlyFor={ONLY_FOR.UNAUTHORIZED} />
    ),
    path: PATHNAMES.REGISTRATION,
  },
  {
    element: <PrivateRoute component={MyClonesCreate} />,
    path: PATHNAMES.CREATE_CLONE,
  },
  {
    element: <PrivateRoute component={MyClonesEdit} />,
    path: PATHNAMES.EDIT_CLONE,
  },
  {
    element: <InquiryItem />,
    path: PATHNAMES.INQUIRY_ITEM,
  },
  {
    element: <CloneItem />,
    path: PATHNAMES.CLONE_ITEM,
  },
  {
    element: <PrivateRoute component={Favorites} onlyFor={ONLY_FOR.AGENT} />,
    path: PATHNAMES.FAVORITES_CLONES,
  },
  {
    element: <PrivateRoute component={Watchlist} />,
    path: PATHNAMES.FAVOURITE_INQUIRIES,
  },
  { element: <InquiryItem />, path: PATHNAMES.INQUIRY_ITEM },
  {
    element: <Inquiries />,
    path: PATHNAMES.INQUIRIES,
  },
  {
    element: <AboutUs />,
    path: PATHNAMES.ABOUT_US,
  },
  {
    element: (
      <PrivateRoute component={CreateInquiry} onlyFor={ONLY_FOR.AGENT} />
    ),
    path: PATHNAMES.CREATE_INQUIRY,
  },
  {
    element: <PrivateRoute component={EditInquiry} onlyFor={ONLY_FOR.AGENT} />,
    path: PATHNAMES.EDIT_INQUIRY,
  },
  {
    element: <UserProfile />,
    path: PATHNAMES.USER_PROFILE,
    children: [
      {
        element: <UserProfileInfo />,
        path: PATHNAMES.USER_PROFILE,
      },
      {
        element: <UserProfileClones />,
        path: PATHNAMES.USER_PROFILE_CLONES,
      },
      {
        element: <UserProfileInquiries />,
        path: PATHNAMES.USER_PROFILE_INQUIRIES,
      },
    ],
  },
  {
    element: <PrivateRoute component={Cabinet} />,
    path: PATHNAMES.CABINET,
    children: [
      {
        element: <Navigate to={PATHNAMES.MY_CLONES} replace />,
        path: PATHNAMES.CABINET,
      },
      {
        element: <MyClones />,
        path: PATHNAMES.MY_CLONES,
      },
      {
        element: (
          <PrivateRoute component={MyInquiries} onlyFor={ONLY_FOR.AGENT} />
        ),
        path: PATHNAMES.MY_INQUIRIES,
      },
      {
        element: <Settings />,
        path: PATHNAMES.SETTINGS,
      },
      //CHANGE - temp (from)
      {
        element: <div className="mx-auto text-2xl text-center">Account</div>,
        path: PATHNAMES.ACCOUNT,
      },
      //CHANGE - temp (to)
      {
        element: <Deals />,
        path: PATHNAMES.DEALS,
      },
      {
        element: <DealItem />,
        path: PATHNAMES.DEAL_ITEM,
      },
    ],
  },
  {
    element: <Opportunities />,
    path: PATHNAMES.OPPORTUNITIES,
  },
  {
    element: <ContactUs />,
    path: PATHNAMES.CONTACT_US,
  },
  {
    element: <Blog />,
    path: PATHNAMES.BLOG,
  },
  {
    element: <BlogItem />,
    path: PATHNAMES.BLOG_ITEM,
  },
  {
    element: <CookiePolicy />,
    path: PATHNAMES.COOKIE_POCILY,
  },
  {
    element: <PrivacyPolicy />,
    path: PATHNAMES.PRIVE_POLICY,
  },
  {
    element: <TermsOfUse />,
    path: PATHNAMES.TERMS_OF_USE,
  },
  {
    element: <NotFound />,
    path: PATHNAMES.NOT_FOUND,
  },
];

const AppRoutes: FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getMetaDataAsync());
    dispatch(getCountriesAsync());
    dispatch(getIndustriesAsync());
    dispatch(getCloneTypesAsync());
    dispatch(getCurrentUserAsync());
  }, [dispatch]);

  return useRoutes(ROUTES);
};

export default AppRoutes;
